/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabasePercentageFieldLook = {
    NumberLook: 'PERCENTAGE_FIELD_NUMBER_LOOK',
    BarChartLook: 'PERCENTAGE_FIELD_BAR_CHART_LOOK',
    PieChartLook: 'PERCENTAGE_FIELD_PIE_CHART_LOOK'
} as const;
export type DatabasePercentageFieldLook = typeof DatabasePercentageFieldLook[keyof typeof DatabasePercentageFieldLook];


export function DatabasePercentageFieldLookFromJSON(json: any): DatabasePercentageFieldLook {
    return DatabasePercentageFieldLookFromJSONTyped(json, false);
}

export function DatabasePercentageFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePercentageFieldLook {
    return json as DatabasePercentageFieldLook;
}

export function DatabasePercentageFieldLookToJSON(value?: DatabasePercentageFieldLook | null): any {
    return value as any;
}

